import axios from 'axios'
import { url } from '@/api/url'
import { HeadersWithCredentials } from '@/api/header'

export const saveUserCompetitionReview = async (competitionId, rating, comment, score) => {
    return await axios.put(
        `${url}/review/save-user-competition-review/${competitionId}`,
        { rating, comment, score },
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const getUserCompetitionReview = async (competitionId) => {
    return await axios.get(`${url}/review/user-competition-review/${competitionId}`, {
        headers: HeadersWithCredentials(),
    })
}

export const getCompetitionReviews = async (competitionId, options = {}) => {
    return await axios.get(`${url}/review/competition-reviews/${competitionId}`, {
        headers: HeadersWithCredentials(),
        params: options,
    })
}

export const replyToReview = async (competitionId, reviewId, organizerReply) => {
    return await axios.put(
        `${url}/review/reply-to-review/${competitionId}/${reviewId}`,
        { organizerReply },
        { headers: HeadersWithCredentials() },
    )
}

export const updateReviewPrivate = async (competitionId, isPrivate) => {
    return await axios.put(
        `${url}/review/private/${competitionId}`,
        { isPrivate },
        { headers: HeadersWithCredentials() },
    )
}

export const deleteReview = async (reviewId) => {
    return await axios.delete(`${url}/review/${reviewId}`, { headers: HeadersWithCredentials() })
}
